<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseReservation"
  backButtonText="Back"
  [backSwipe]="backSwipeConfig"
  (click)="back.emit()"
/>
